import { CATEGORY, FEATURE, HomeTypeExplorer, TEXT_CATEGORY } from '../../types/home';

const deepPath = process.env.REACT_APP_DEEP_PATH || '';

export const DEFAULT_HOME = {
  HOMME: {
    SHOP: '/shop',
    PLAY: '/play',
    ARTICLES: '/articles',
    REWARDS: '/rewards',
  },
  PROMOTION: {
    HEADING: 'Just In',
    TITLE: 'Just In',
    CTA_TEXT: 'EXPLORE',
    CTA_ECOM_PRODUCT: '/product/',
    CTA_COACHING_PLANS: '/coachingPlans',
    CTA_SHOP_DROP: '/shopDrops',
    CTA_DRILLS_FOR_YOU: '/drillsForYou',
    CTA_VIEW_SCORES: '/viewScores',
    CTA_POST_SCORES: '/postScore',
    CTA_GAME_PROFILE: '/gameProfile',
    CTA_CART: '/cart',
    CTA_FITTINGS: '/fittings',
    CTA_MY_BAG: '/mybag',
    CTA_SUBSCRIPTION: '/subscription',
    CTA_TOUR_TRASH: '/tour-trash',
    CTA_TTB: '/ttb',
    CTA_INSIGHTS: '/insights',
    CTA_COMPARE_CLUB: '/compare-club',
    CTA_STATS: '/stats',
    CTA_REFERRAL: '/referral-email',
    CTA_PROFILE: '/profile',
    CTA_PERKS: '/perks',
    CTA_CLUB_RECOMMENDER: '/club-recommender',
    CTA_MYTM_ON_COURSE: 'https://v28z.test-app.link',
    CUSTOM_URL: '',
  },
  INSIGHTS: {
    HEADING: 'Insights',
    COLOR: '#262729',
    TITLE: '{{insightTitle}}',
    DESCRIPTION: '{{insightDescription}}',
    CTA_TEXT: 'View All Insights',
    CTA_LINK: '/insights',
    EXTRA_DATA: {
      insightId: '{{insightId}}',
      chartType: '{{chartType}}',
      xAxisTitle: '{{xAxisTitle}}',
      xAxisUnits: '{{xAxisUnits}}',
      yAxisTitle: '{{yAxisTitle}}',
      yAxisUnits: '{{yAxisUnits}}',
      chartData: '{{chartData}}',
      numberLabel: '{{numberLabel}}',
    },
  },
  HANDICAP: {
    HEADING: 'TaylorMade Handicap',
    COLOR: '#04BE4B',
    TITLE: 'Handicap Index',
    DESCRIPTION: '{{handicapDescription}}',
    CTA_TEXT: 'Post a Score',
    CTA_LINK: '/post-score',
    EXTRA_DATA: {
      handicapIndex: '{{handicapIndex}}',
      isTrendingDownward: '{{isTrendingDownward}}',
      isTrendingUpward: '{{isTrendingUpward}}',
    },
  },
  SCORE: {
    HEADING: 'Scores',
    COLOR: '#01666F',
    TITLE: '{{averageScoreStr}}',
    DESCRIPTION: 'Average Score',
    CTA_TEXT: 'View All Scores',
    CTA_LINK: '/scores',
    EXTRA_DATA: [
      {
        label: 'Round',
        count: '{{totalRounds}}',
      },
      {
        label: 'Low',
        count: '{{lowestScore}}',
      },
      {
        label: 'High',
        count: '{{highestScore}}',
      },
    ],
  },
  TARGET: {
    HEADING: 'Target Score',
    COLOR: '#4E5643',
    TITLE: '{{strokeToTarget}}',
    DESCRIPTION: 'Strokes to target',
    CTA_TEXT: 'Adjust Target Score',
    CTA_LINK: '/target-score',
    EXTRA_DATA: [
      {
        label: 'Average',
        count: '{{averageScore}}',
      },
      {
        label: 'Target',
        count: '{{targetScore}}',
      },
    ],
  },
  EXPLORE: {
    CTA_TEXT: 'Explorer',
    CTA_LINK: '/content/{{content.id}}',
    CTA_LINK_PRODUCT: '/product/{{product.id}}',
    BACKGROUND_IMAGE: '{{content.primaryImage}}',
    TITLE: '{{content.title}}',
    TITLE_PRODUCT: '{{product.name}}',
    BACKGROUND_IMAGE_PRODUCT: '{{product.image_groups[0].images[0].link}}',
    COUNTRIES: ['USA', 'CAN'],
  },
};

export const HOME_EXPLORERS = [
  { index: 0, value: HomeTypeExplorer.DRILL_OF_THE_WEEK },
  { index: 1, value: HomeTypeExplorer.DRILL_OF_THE_MONTH },
  { index: 2, value: HomeTypeExplorer.FEATURED_STORY },
  { index: 3, value: HomeTypeExplorer.FEATURED_VIDEO },
  { index: 4, value: HomeTypeExplorer.MEMBER_ONLY_EXCLUSIVE },
  { index: 5, value: HomeTypeExplorer.ON_TOUR },
];

export enum HomeWidgetGroupKey {
  HomeTile = 'HomeTile',
  HomeExplorer = 'HomeExplorer',
}

export const JUST_IN_CATEGORIES = [
  {
    text: TEXT_CATEGORY[CATEGORY.CMS],
    value: CATEGORY.CMS,
  },
  {
    text: TEXT_CATEGORY[CATEGORY.ECOM_PRODUCT],
    value: CATEGORY.ECOM_PRODUCT,
  },
  {
    text: TEXT_CATEGORY[CATEGORY.APP_DEEP_LINK],
    value: CATEGORY.APP_DEEP_LINK,
  },
  {
    text: TEXT_CATEGORY[CATEGORY.WEB_LINK],
    value: CATEGORY.WEB_LINK,
  },
  {
    text: TEXT_CATEGORY[CATEGORY.NO_CTA],
    value: CATEGORY.NO_CTA,
  },
];

export const APP_DEEP_LINK_FEATURES = [
  {
    value: FEATURE.COACHING_PLANS,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_COACHING_PLANS,
  },
  {
    value: FEATURE.SHOP_DROP,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_SHOP_DROP,
  },
  {
    value: FEATURE.DRILLS_FOR_YOU,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_DRILLS_FOR_YOU,
  },
  {
    value: FEATURE.VIEW_SCORES,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_VIEW_SCORES,
  },
  {
    value: FEATURE.POST_SCORES,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_POST_SCORES,
  },
  {
    value: FEATURE.GAME_PROFILE,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_GAME_PROFILE,
  },
  {
    value: FEATURE.CART,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_CART,
  },
  {
    value: FEATURE.FITTINGS,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_FITTINGS,
  },
  {
    value: FEATURE.MY_BAG,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_MY_BAG,
  },
  {
    value: FEATURE.SUBSCRIPTION,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_SUBSCRIPTION,
  },
  {
    value: FEATURE.TOUR_TRASH,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_TOUR_TRASH,
  },
  {
    value: FEATURE.TTB,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_TTB,
  },
  {
    value: FEATURE.INSIGHTS,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_INSIGHTS,
  },
  {
    value: FEATURE.COMPARE_CLUB,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_COMPARE_CLUB,
  },
  {
    value: FEATURE.STATS,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_STATS,
  },
  {
    value: FEATURE.MY_TAYLORMADE_ON_COURSE,
    ctaLink: DEFAULT_HOME.PROMOTION.CTA_MYTM_ON_COURSE,
  },
  {
    value: FEATURE.CLUB_RECOMMENDER,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_CLUB_RECOMMENDER,
  },
  {
    value: FEATURE.PERK,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_PERKS,
  },
  {
    value: FEATURE.REFERRAL,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_REFERRAL,
  },
  {
    value: FEATURE.PROFILE,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_PROFILE,
  },
];

export const APP_DEEP_LINK_FEATURES_V2 = [
  {
    value: FEATURE.PLAY,
    ctaLink: deepPath + DEFAULT_HOME.HOMME.PLAY,
  },
  {
    value: FEATURE.SHOP,
    ctaLink: deepPath + DEFAULT_HOME.HOMME.SHOP,
  },
  {
    value: FEATURE.ARTICLES,
    ctaLink: deepPath + DEFAULT_HOME.HOMME.ARTICLES,
  },
  {
    value: FEATURE.REWARDS,
    ctaLink: deepPath + DEFAULT_HOME.HOMME.REWARDS,
  },
  {
    value: FEATURE.CLUB_RECOMMENDER,
    ctaLink: deepPath + DEFAULT_HOME.PROMOTION.CTA_CLUB_RECOMMENDER,
  },
];
